/*global */


/**
 * Extension to search cities in ZIP Codes
 */
var extension = {} ;
extension.name = "country" ;

var options = {country: "FR"} ;


extension.extendsGlobal = {} ;
extension.extendsGlobal.country = {} ;
/**
 * @typedef CountryOptions
 * @type {object}
 * @property {string} country the country to use (FR, GB, DE, ES)
 */

/**
 * Set country options
 * 
 * @example
 * VeloxWebView.country.setOptions({country: "FR"}) ;
 * 
 * @param {CountryOptions} options 
 */
extension.extendsGlobal.country.setOptions = function(optionsP){
    options = optionsP ;
};

extension.extendsGlobal.country.get = function(){
    return options.country ;
};

module.exports = extension ;